<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 308 308" style="enable-background:new 0 0 308 308;" xml:space="preserve">
        <g id="XMLID_468_">
            <path id="XMLID_469_" class="whatsapp" d="M227.9,177c-0.6-0.3-23.1-11.3-27-12.8c-1.6-0.6-3.4-1.2-5.2-1.2c-3,0-5.6,1.5-7.6,4.5
        c-2.2,3.3-9,11.3-11.1,13.6c-0.3,0.3-0.6,0.7-0.9,0.7c-0.2,0-3.7-1.4-4.7-1.9c-24.1-10.5-42.4-35.6-44.9-39.9
        c-0.4-0.6-0.4-0.9-0.4-0.9c0.1-0.3,0.9-1.1,1.3-1.6c1.2-1.2,2.5-2.8,3.8-4.3c0.6-0.7,1.2-1.5,1.8-2.2c1.9-2.2,2.7-3.8,3.6-5.8
        l0.5-1c2.3-4.7,0.3-8.6-0.3-9.9c-0.5-1.1-10-23.9-11-26.3c-2.4-5.8-5.6-8.5-10.1-8.5c-0.4,0,0,0-1.7,0.1
        c-2.1,0.1-13.6,1.6-18.7,4.8c-5.4,3.4-14.5,14.2-14.5,33.2c0,17.1,10.9,33.3,15.5,39.5c0.1,0.2,0.3,0.5,0.6,0.9
        c17.9,26.1,40.2,45.4,62.7,54.5c21.7,8.7,32,9.7,37.9,9.7c0,0,0,0,0,0c2.5,0,4.4-0.2,6.2-0.4l1.1-0.1c7.5-0.7,24-9.2,27.8-19.7
        c3-8.2,3.7-17.2,1.8-20.5C233.2,179.5,230.8,178.4,227.9,177z" />
            <path id="XMLID_470_" class="whatsapp" d="M156.7,0C73.3,0,5.5,67.4,5.5,150.1c0,26.8,7.2,53,20.7,75.9l-26,76.6c-0.5,1.4-0.1,3,0.9,4.1
        c0.8,0.8,1.8,1.2,2.9,1.2c0.4,0,0.8-0.1,1.2-0.2l79.9-25.4c21.9,11.7,46.6,17.9,71.6,17.9c83.4,0,151.3-67.3,151.3-150.1
        C308,67.4,240.1,0,156.7,0z M156.7,269c-23.5,0-46.3-6.8-65.9-19.7c-0.7-0.4-1.4-0.7-2.2-0.7c-0.4,0-0.8,0.1-1.2,0.2l-40,12.7
        l12.9-38.1c0.4-1.2,0.2-2.6-0.6-3.6c-14.9-20.4-22.8-44.5-22.8-69.7c0-65.5,53.8-118.9,119.8-118.9c66.1,0,119.8,53.3,119.8,118.9
        C276.5,215.7,222.8,269,156.7,269z" />
        </g>
    </svg>
</template>
<style type="text/css">
.dark .whatsapp {
    fill: #FCEA0D;
}
.whatsapp {
    fill: #47c756;
}

</style>
